import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EntryExit, WheelChairSmallSvg, LocationSvg, GateArr } from '../../common/svg/AllSvg';
import { useDeviceType } from '../../../shared/utils/useDeviceType';

const GatesDetails = () => {
	const [data, setData] = useState<any[]>([])
	const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
	const [hover, setHover] = useState<any>("")
	const { t } = useTranslation('common');
	const isMobile = useDeviceType();

	useEffect(() => {
		if (!!stationDetailData) {
			setData(stationDetailData?.gates)
		}
	}, [stationDetailData])

	return (
		<>
			{/* Entry and Exit */}
			<div className="flex flex-col container pt-[30px] xlx:pt-[40px]" id="gates">
				<div className="flex items-center gap-[9px]">
					<EntryExit />
					<h5 className='font-bold text-secGreen uppercase'>{t('passenger.station_detail.entry_and_exit')}</h5>
				</div>
				<div className="mt-[25px] w-full max-md:max-w-full">
					<div className="grid grid-cols-1 xsm:grid-cols-2 mms:grid-cols-3 xl:grid-cols-4 gap-[20px]">
						{Array.isArray(data) && data?.map((item: any, index: number) => (
							<button key={index} className="border border-[#059db280] dark:border-[#ffffff80] p-[15px] xlx:p-[18px] flex flex-col gap-[20px] rounded-[15px] min-h-[95px] xlx:min-h-[105px] justify-between transition-all duration-100 relative bg-white dark:bg-bgDarkDull cursor-default" onMouseEnter={() => setHover(index?.toString())} onMouseLeave={() => setHover("")} onFocus={() => !isMobile && setHover(index?.toString())} onClick={() => setHover(index?.toString())} onBlur={() => setHover("")}>
								<div className='w-full flex items-center justify-between gap-[8px]'>
									<h4 className='text-primaryText dark:text-white font-semibold'>{item?.gate_name}</h4>

									<div className='flex items-center gap-[7px]'>
										<p className={`h-[18px] flex items-center justify-center px-[6px] ${item?.status?.toLowerCase() === "open" ? "bg-success" : "bg-secDarkRed"} text-white font-semibold uppercase rounded-[50px] w-fit`}>
											{item?.status}
										</p>

										<div className='flex items-center gap-[4px]'>
											<WheelChairSmallSvg />
											<p className='text-blackDull dark:text-textBlackDull font-semibold'>{item.divyang_friendly ? t('passenger.station_detail.yes') : t('passenger.station_detail.no')}</p>
										</div>
									</div>
								</div>

								{item?.locations?.length > 0 && <>
									{item?.locations?.length > 1 ? <div className='flex items-center gap-[10px]'>
										<div className='flex gap-[8px]'>
											<LocationSvg />
											<h6 className='text-blackDull dark:text-textBlackDull font-medium text-left'>
												{item?.locations?.[0]?.location}
											</h6>
										</div>

										<div className='bg-[#FBA903] bg-opacity-[0.1] h-[20px] rounded-[30px] px-[10px] flex items-center justify-center gap-[6px] whitespace-nowrap'>
											<p className='text-secOrange font-semibold'>{item?.locations?.length - 1} {t('passenger.station_detail.more')}</p>
											<GateArr />
										</div>
									</div> :
										<div className='flex gap-[8px]'>
											<LocationSvg />
											<h6 className='text-blackDull dark:text-textBlackDull font-medium text-left'>
												{item?.locations?.[0]?.location}
											</h6>
										</div>
									}
								</>}

								{(hover === index?.toString() && item?.locations?.length > 1) && <div className="border border-[#059db280] dark:border-[#ffffff80] p-[16px] xlx:p-[20px] flex flex-col gap-[20px] rounded-[15px] min-h-[95px] xlx:min-h-[105px] justify-between transition-all duration-100 absolute top-[-1.5px] left-[-1.5px] right-[-1.5px] bg-white dark:bg-bgDarkDull z-[1] gates-card shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)]" onMouseEnter={() => setHover(index?.toString())} onMouseLeave={() => setHover("")}>
									<div className='w-full flex items-center justify-between gap-[8px]'>
										<h4 className='text-primaryText dark:text-white font-semibold'>{item?.gate_name}</h4>

										<div className='flex items-center gap-[7px]'>
											<p className={`h-[18px] flex items-center justify-center px-[6px] ${item?.status?.toLowerCase() === "open" ? "bg-success" : "bg-secDarkRed"} text-white font-semibold uppercase rounded-[50px] w-fit`}>
												{item?.status}
											</p>

											<div className='flex items-center gap-[4px]'>
												<WheelChairSmallSvg />
												<p className='text-blackDull dark:text-textBlackDull font-semibold'>{item.divyang_friendly ? t('passenger.station_detail.yes') : t('passenger.station_detail.no')}</p>
											</div>
										</div>
									</div>

									{item?.locations?.length > 0 && <>
										{item?.locations?.length > 1 ? <>
											{hover === index?.toString() ? <div className='flex flex-col gap-[10px]'>
												{Array.isArray(item?.locations) && item?.locations?.map((i: any, idx: number) => (
													<div className='flex gap-[8px]' key={idx}>
														<LocationSvg />
														<h6 className='text-blackDull dark:text-textBlackDull font-medium text-left'>
															{i?.location}
														</h6>
													</div>
												))}
											</div> :
												<div className='flex items-center gap-[10px]'>
													<div className='flex gap-[8px]'>
														<LocationSvg />
														<h6 className='text-blackDull dark:text-textBlackDull font-medium text-left'>
															{item?.locations?.[0]?.location}
														</h6>
													</div>

													<div className='bg-[#FBA903] bg-opacity-[0.1] h-[20px] rounded-[30px] px-[10px] flex items-center justify-center gap-[6px] whitespace-nowrap'>
														<p className='text-secOrange font-semibold'>{item?.locations?.length - 1} {t('passenger.station_detail.more')}</p>
														<GateArr />
													</div>
												</div>
											}
										</> :
											<div className='flex gap-[8px]'>
												<LocationSvg />
												<h6 className='text-blackDull dark:text-textBlackDull font-medium text-left'>
													{item?.locations?.[0]?.location}
												</h6>
											</div>
										}
									</>}
								</div>}
							</button>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default GatesDetails;